export enum FeatureToggle {
  marketingToolingEnabled = 'rt_rfm_v2_enabled',
  marketingToolingV2DisabledOverride = 'rt_rfm_v2_disabled_overrides',
  marketingToolingRetailerEnabled = 'rt_rfm_v2_retailer_enabled',
  marketingToolingRetailerDisabledOverride = 'rt_rfm_v2_retailer_disabled_override',
  segmentLibraryEnabled = 'rt_segment_library_v2_enabled',
  targetingApiSegmentToolingEnabled = 'rt_targeting_api_segment_tooling_enabled',
  budgetCappingManagementEnabled = 'rt_marketing_tooling_budget_capping_management_enabled',
  memberIdCsvToolingEnabled = 'rt_loyalty_id_csv_tooling_enabled',
  onSiteAndCrmCampaigns = 'rt_mt_on_site_and_crm_campaigns',
  enableLotusCRMCampaign = 'rt_mt_enable_lotus_crm_campaign',
  retailerDepartmentOfferEnabled = 'rt_retailer_department_offer_enabled',
  // Reuses the legacy RFM template toggle so EI rollout is a single audience across domains.
  embeddedInstacartEnabled = 'rt_campaigns_v2_template_embedded_instacart_enabled',
  itemLevelOfferStackabilityEnabled = 'rt_item_level_offer_stackability_enabled',
  showAllFeeRewardOptions = 'rt_mt_show_all_fee_reward_options',
  offlineDiscoverabilityEnabled = 'rt_mt_offline_discoverability_enabled',
}
